module.exports = __webpack_public_path__ + "static/media/Walls.9a5fe955.png";